/* Upload Your Own (sections/digital-upload.liquid): the shopper chooses the white border width per print.
   Owner, 2026-10-08: pick "With White Border", get a slider for the thickness, confirm, and that exact file is
   saved and uploaded, so the team prints it as is instead of adding the border by hand.

   - Panel under the Border options (only while the active photo has a white border): four named widths, Thin /
     Medium (recommended) / Thick / Extra thick, even on all sides. NO cm on the page (owner 2026-10-09: trimming
     and the frame lip mean the visible margin is never exact, so a number invites "it's 1 cm off" complaints); the
     cm goes on the order as a hidden property for the team. A mini preview of the paper sits beside the choice;
     dragging the photo (mini or main preview) moves what shows inside the border.
   - Main preview: the plain frame image drawn around the paper, then the white margin, then the photo,
     all from the chosen width (replaces the fixed frame-plus-mat image while a white border is on).
   - The file: same pixel size as the uploaded crop, white margin of the chosen width, photo scaled into the
     space inside it (cover, at the chosen position). Uploaded to the store's own print storage (/print).
     So the file's resolution, and the iPhone canvas limit, are the same as for the crop.
   - Add to cart (addAllToCart calls window.smwWB.ready() and .props()): any white-border photo that is not
     saved yet is saved first; the cart line's "Cropped Image" becomes the bordered file, with the width and the
     original crop on the line. The "Check your print" pop-up shows the bordered file.
   Loop-safe: the observers watch the image grid's frame/border attributes and the preview's children and img
   src; this script writes only the preview's class / custom properties, the img's inline size, and its own panel. */
(function () {
  if (window.smwWB) return;

  var CFG = {};
  try { CFG = JSON.parse(document.getElementById('smw-wb-config').textContent); } catch (e) {}
  var FRAMES = CFG.frames || {};
  // Frame band on the plain ISO frame images: 33 px on the 849 x 1200 (portrait) / 1200 x 849 (landscape) files.
  var BAND = { portrait: [33 / 849, 33 / 1200], landscape: [33 / 1200, 33 / 849] };
  var SIZE_CM = { A4: [21, 29.7], A3: [29.7, 42], A2: [42, 59.4], A1: [59.4, 84.1], B1: [70.7, 100], A0: [84.1, 118.9], B0: [100, 141] };
  // Each width is a share of the print's short side, rounded to 0.5 cm, with a floor, and at least 0.5 cm wider than
  // the one before: A4 1 / 1.5 / 2 / 2.5 cm, A2 1.5 / 2 / 3.5 / 5, A1 2 / 3 / 5 / 7, B0 3 / 5 / 8 / 12.
  var LEVELS = [
    { name: 'Thin', pct: 0.03, min: 1 },
    { name: 'Medium', pct: 0.05, min: 1.5 },
    { name: 'Thick', pct: 0.08, min: 2 },
    { name: 'Extra thick', pct: 0.12, min: 2.5 }
  ];
  var DEFAULT_LEVEL = 1;

  function activeState() { try { return activeImageId ? imagesState[activeImageId] : null; } catch (e) { return null; } }
  function allStates() { try { return Object.keys(imagesState).map(function (k) { return imagesState[k]; }); } catch (e) { return []; } }
  function printUrl() { try { return SMW_UPSCALER_URL + '/print'; } catch (e) { return 'https://smw-upscaler.stylemywall.workers.dev/print'; } }

  function sizeKey(st) { return String(st.sizeLabel || '').split(':')[0].trim(); }
  // Paper size in cm for this photo's size and orientation, from the page's own size list.
  function paper(st) {
    var k = sizeKey(st), d = null;
    try {
      var m = getUniqueSizesMap(), s = m.get(k) || m.get(st.sizeLabel);
      if (s && s.w && s.h) d = /in/i.test(s.unit || '') ? [s.w * 2.54, s.h * 2.54] : [s.w, s.h];
    } catch (e) {}
    d = d || SIZE_CM[k];
    if (!d) return null;
    var lo = Math.min(d[0], d[1]), hi = Math.max(d[0], d[1]);
    return st.orientation === 'landscape' ? { w: hi, h: lo, short: lo, key: k } : { w: lo, h: hi, short: lo, key: k };
  }
  function half(v) { return Math.round(v * 2) / 2; }
  function levelCm(p, i) {
    var v = 0;
    for (var j = 0; j <= i; j++) v = Math.max(LEVELS[j].min, half(p.short * LEVELS[j].pct), v + 0.5);
    return v;
  }
  function fmt(v) { return (v % 1 ? v.toFixed(1) : String(v)) + ' cm'; }

  function isOn(st) { return !!st && /white/i.test(st.borderOption || '') && !/Canvas|Leaf/i.test(st.frame || ''); }
  function wb(st) { return st.smwWB || (st.smwWB = { level: DEFAULT_LEVEL, x: 50, y: 50, file: '', fileKey: '', job: null, err: false }); }
  function cmFor(st) {
    var p = paper(st);
    if (!p) return null;
    return levelCm(p, wb(st).level);
  }
  function keyFor(st) { var w = wb(st); return [st.uploadedImage, sizeKey(st), st.orientation, cmFor(st), Math.round(w.x), Math.round(w.y)].join('|'); }
  function saved(st) { var w = wb(st); return !!w.file && w.fileKey === keyFor(st); }
  function live(st) { return !!(st && st.uploaded && st.uploadedImage && isOn(st) && paper(st)); }

  /* ---------- the print file ---------- */

  var imgCache = {};
  function getImg(src) {
    if (imgCache[src]) return imgCache[src];
    var p = new Promise(function (res, rej) {
      var i = new Image();
      i.crossOrigin = 'anonymous';
      i.onload = function () { res(i); };
      i.onerror = function () { delete imgCache[src]; rej(new Error('Could not load the photo')); };
      i.src = src;
    });
    imgCache = {}; // keep only the latest photo in memory
    imgCache[src] = p;
    return p;
  }

  // White margin of the chosen width, photo cover-fitted inside it at the chosen position.
  function render(img, st, maxSide) {
    var p = paper(st), cm = cmFor(st), w = wb(st);
    var W = img.naturalWidth, H = img.naturalHeight, k = maxSide && Math.max(W, H) > maxSide ? maxSide / Math.max(W, H) : 1;
    var cw = Math.round(W * k), ch = Math.round(H * k);
    var c = document.createElement('canvas');
    c.width = cw; c.height = ch;
    var g = c.getContext('2d');
    g.fillStyle = '#fff';
    g.fillRect(0, 0, cw, ch);
    var m = cm * (cw / p.w), iw = cw - 2 * m, ih = ch - 2 * m;
    var s = Math.max(iw / W, ih / H), dw = W * s, dh = H * s;
    g.save();
    g.beginPath(); g.rect(m, m, iw, ih); g.clip();
    g.imageSmoothingEnabled = true; g.imageSmoothingQuality = 'high';
    g.drawImage(img, m + (iw - dw) * w.x / 100, m + (ih - dh) * w.y / 100, dw, dh);
    g.restore();
    return c;
  }

  function toBlob(c, q) {
    return new Promise(function (res, rej) {
      try { c.toBlob(function (b) { b ? res(b) : rej(new Error('Could not make the file')); }, 'image/jpeg', q); } catch (e) { rej(e); }
    });
  }

  function upload(blob) {
    return fetch(printUrl(), { method: 'POST', headers: { 'Content-Type': 'image/jpeg' }, body: blob })
      .then(function (r) { if (!r.ok) throw new Error('Upload failed (' + r.status + ')'); return r.json(); })
      .then(function (d) { var u = d && ((d.data && d.data.url) || d.url); if (!u) throw new Error('Upload failed'); return u; });
  }

  function save(st) {
    var w = wb(st), key = keyFor(st);
    if (w.file && w.fileKey === key) return Promise.resolve(w.file);
    if (w.job && w.job.key === key) return w.job.p;
    w.err = false;
    var p = getImg(st.uploadedImage)
      .then(function (img) { return toBlob(render(img, st, 0), 0.95); })
      .then(upload)
      .then(function (url) {
        if (w.job && w.job.key === key) w.job = null;
        w.file = url; w.fileKey = key;
        schedule();
        return url;
      }, function (e) {
        if (w.job && w.job.key === key) { w.job = null; w.err = true; }
        schedule();
        throw e;
      });
    w.job = { key: key, p: p };
    schedule();
    return p;
  }

  // Called by addAllToCart() before it builds the cart lines.
  function ready(button) {
    var todo = allStates().filter(function (st) { return live(st) && !saved(st); });
    if (!todo.length) return Promise.resolve(true);
    if (button) button.textContent = 'Saving your white border' + (todo.length > 1 ? 's' : '') + '...';
    return Promise.all(todo.map(save)).then(function () { return true; }, function (e) {
      console.error('White border save failed:', e);
      alert('We couldn\'t save your white border. Please check your connection and try again.');
      return false;
    });
  }

  // Called by addAllToCart() for each cart line.
  function props(st, pr) {
    if (!live(st) || !saved(st)) return;
    pr['_Original crop'] = pr['Cropped Image'];
    pr['Cropped Image'] = wb(st).file;
    pr['White border'] = LEVELS[wb(st).level].name;
    pr['_White border width'] = fmt(cmFor(st)) + ' on all sides';
    pr['_Print file'] = 'White border is already on the file. Print as is.';
  }

  // The "Check your print" pop-up shows the bordered file.
  function wrapApprove() {
    var orig = window.smwApprovePrints;
    if (!orig || orig.__smwWB) return;
    var f = function (sts) {
      return orig.call(this, (sts || []).map(function (s) {
        if (!live(s) || !saved(s)) return s;
        var o = Object.create(s);
        o.uploadedImage = wb(s).file;
        o.borderOption = 'White border: ' + LEVELS[wb(s).level].name;
        return o;
      }));
    };
    f.__smwWB = true;
    window.smwApprovePrints = f;
  }

  /* ---------- live preview ---------- */

  function frameUrl(st) { return (FRAMES[st.orientation === 'landscape' ? 'landscape' : 'portrait'] || {})[st.frame] || ''; }

  // Layout of the main preview: box size, frame band and white margin in px.
  var geo = null;
  function applyPreview(st) {
    var fr = document.querySelector('.left-frame-preview .image-frame');
    var img = fr && fr.querySelector('img');
    if (!fr) return;
    var on = live(st) && img && img.getAttribute('src') === st.uploadedImage;
    if (!on) {
      if (fr.classList.contains('smw-wb-on')) {
        fr.classList.remove('smw-wb-on', 'smw-wb-fixed', 'smw-wb-paper');
        if (img) { img.style.removeProperty('width'); img.style.removeProperty('height'); }
      }
      geo = null;
      return;
    }
    var wrap = fr.parentElement;
    var mk = img.getAttribute('src') + '|' + (wrap ? wrap.clientWidth : 0) + '|' + window.innerWidth;
    if (img.__smwMk !== mk || !fr.classList.contains('smw-wb-on')) {
      // Measure the photo's normal layout once, then hold that box while the border is on.
      // (without the old fixed 20px white CSS border, which would shrink it on phones)
      fr.classList.add('smw-wb-m');
      fr.classList.remove('smw-wb-on');
      img.style.removeProperty('width'); img.style.removeProperty('height');
      var r = img.getBoundingClientRect();
      fr.classList.remove('smw-wb-m');
      if (!r.width || !img.naturalWidth) return; // not loaded yet - the load listener runs this again
      img.__smwMk = mk; img.__smwW = r.width; img.__smwH = r.height;
    }
    var W = img.__smwW, H = img.__smwH, p = paper(st), w = wb(st), url = frameUrl(st);
    var band = url ? BAND[st.orientation === 'landscape' ? 'landscape' : 'portrait'] : [0, 0];
    var bx = W * band[0], by = H * band[1], m = cmFor(st) * ((W - 2 * bx) / p.w);
    geo = { el: img, W: W, H: H, px: bx + m, py: by + m, nw: img.naturalWidth, nh: img.naturalHeight };
    setVar(fr, '--smw-wb-frame', url ? 'url("' + url + '")' : 'none');
    setVar(fr, '--smw-wb-pad', geo.py.toFixed(1) + 'px ' + geo.px.toFixed(1) + 'px');
    setVar(fr, '--smw-wb-pos', w.x.toFixed(1) + '% ' + w.y.toFixed(1) + '%');
    var ws = W + 'px', hs = H + 'px';
    if (img.style.width !== ws) img.style.width = ws;
    if (img.style.height !== hs) img.style.height = hs;
    if (!fr.classList.contains('smw-wb-on')) fr.classList.add('smw-wb-on');
    var sl = slack(geo);
    fr.classList.toggle('smw-wb-fixed', sl.x < 1 && sl.y < 1);
    fr.classList.toggle('smw-wb-paper', !url);
  }

  function setVar(el, k, v) { if (el.style.getPropertyValue(k) !== v) el.style.setProperty(k, v); }

  // How far the photo can move inside the white margin (px), for a box with padding px/py.
  function slack(g) {
    var iw = g.W - 2 * g.px, ih = g.H - 2 * g.py;
    if (iw <= 0 || ih <= 0 || !g.nw) return { x: 0, y: 0 };
    var s = Math.max(iw / g.nw, ih / g.nh);
    return { x: g.nw * s - iw, y: g.nh * s - ih };
  }

  /* ---------- panel ---------- */

  var panel, els = {};
  function buildPanel() {
    if (panel && document.body.contains(panel)) return panel;
    var host = document.querySelector('.amr-Border .fk-line-item-parent-effect');
    if (!host) return null;
    panel = document.createElement('div');
    panel.className = 'smw-wb';
    panel.hidden = true;
    panel.innerHTML =
      '<div class="smw-wb__mini"><img alt="Your print with its white border" draggable="false"></div>' +
      '<div class="smw-wb__ctl">' +
        '<div class="smw-wb__top"><span class="smw-wb__lbl" id="smwWbLbl">Border width</span><span class="smw-wb__val"></span><span class="smw-wb__tag" hidden>Recommended</span></div>' +
        '<p class="smw-wb__hint"></p>' +
      '</div>' +
      '<div class="smw-wb__opts" role="radiogroup" aria-labelledby="smwWbLbl">' +
        LEVELS.map(function (l, i) { return '<button type="button" role="radio" aria-checked="false" data-wb-level="' + i + '">' + l.name + '</button>'; }).join('') +
      '</div>' +
      '<p class="smw-wb__note">Widths are a guide. Trimming and the edge of a frame can make the visible border a little narrower.</p>' +
      '<div class="smw-wb__foot"><button type="button" class="smw-wb__ok">Confirm border</button><span class="smw-wb__status" role="status"></span></div>';
    host.parentNode.insertBefore(panel, host.nextSibling);
    els = {
      mini: panel.querySelector('.smw-wb__mini'), miniImg: panel.querySelector('.smw-wb__mini img'),
      val: panel.querySelector('.smw-wb__val'), tag: panel.querySelector('.smw-wb__tag'), opts: [].slice.call(panel.querySelectorAll('[data-wb-level]')),
      hint: panel.querySelector('.smw-wb__hint'), ok: panel.querySelector('.smw-wb__ok'), status: panel.querySelector('.smw-wb__status')
    };
    els.opts.forEach(function (b) {
      b.addEventListener('click', function () {
        var st = activeState();
        if (!live(st)) return;
        wb(st).level = parseInt(b.getAttribute('data-wb-level'), 10);
        wb(st).err = false;
        update();
      });
    });
    els.ok.addEventListener('click', function () {
      var st = activeState();
      if (!live(st) || saved(st)) return;
      save(st).catch(function (e) { console.error('White border save failed:', e); });
    });
    bindPan(els.miniImg, function () {
      var st = activeState(), r = els.miniImg.getBoundingClientRect();
      if (!live(st) || !r.width) return null;
      var m = cmFor(st) * (r.width / paper(st).w);
      return { W: r.width, H: r.height, px: m, py: m, nw: els.miniImg.naturalWidth, nh: els.miniImg.naturalHeight };
    });
    return panel;
  }

  function setText(el, t) { if (el.textContent !== t) el.textContent = t; }
  function setAttr(el, k, v) { if (el.getAttribute(k) !== String(v)) el.setAttribute(k, v); }

  function refreshPanel(st) {
    if (!buildPanel()) return;
    var on = live(st);
    if (panel.hidden === on) panel.hidden = !on;
    if (!on) return;
    var p = paper(st), w = wb(st), cm = cmFor(st);
    els.opts.forEach(function (b, i) { setAttr(b, 'aria-checked', i === w.level); });
    setText(els.val, LEVELS[w.level].name);
    if (els.tag.hidden === (w.level === DEFAULT_LEVEL)) els.tag.hidden = w.level !== DEFAULT_LEVEL;
    var hint = 'Even on all sides, inside your ' + p.key + ' print.';
    var g = geo || null, sl = g ? slack(g) : { x: 0, y: 0 };
    if (sl.x >= 1 || sl.y >= 1) hint += ' Drag the photo to choose what shows.';
    setText(els.hint, hint);
    // mini preview of the paper
    if (els.miniImg.getAttribute('src') !== st.uploadedImage) { els.miniImg.crossOrigin = 'anonymous'; els.miniImg.src = st.uploadedImage; }
    var ar = (st.cropData && st.cropData.width && st.cropData.height) ? st.cropData.width / st.cropData.height : p.w / p.h;
    var ars = ar.toFixed(4);
    if (els.miniImg.style.aspectRatio !== ars) els.miniImg.style.aspectRatio = ars;
    var miniW = els.mini.clientWidth || 82;
    setVar(panel, '--smw-wb-mini-pad', (cm * miniW / p.w).toFixed(1) + 'px');
    setVar(panel, '--smw-wb-pos', w.x.toFixed(1) + '% ' + w.y.toFixed(1) + '%');
    els.mini.classList.toggle('smw-wb-fixed', sl.x < 1 && sl.y < 1);
    // confirm state
    var isSaved = saved(st), busy = !!(w.job && w.job.key === keyFor(st));
    panel.classList.toggle('is-saved', isSaved);
    panel.classList.toggle('is-error', !!w.err && !busy && !isSaved);
    setText(els.ok, isSaved ? 'Border saved' : busy ? 'Saving...' : 'Confirm border');
    els.ok.disabled = isSaved || busy;
    setText(els.status, isSaved ? '✓ This is the file we\'ll print.' : busy ? 'Saving your print file...' : w.err ? 'Couldn\'t save. Please try again.' : '');
  }

  /* ---------- drag to move the photo inside the border ---------- */

  function bindPan(el, geom) {
    var start = null;
    el.addEventListener('pointerdown', function (e) {
      var st = activeState(), g = geom();
      if (!g || !live(st)) return;
      var sl = slack(g);
      if (sl.x < 1 && sl.y < 1) return;
      start = { x: e.clientX, y: e.clientY, wx: wb(st).x, wy: wb(st).y, sl: sl, st: st };
      try { el.setPointerCapture(e.pointerId); } catch (x) {}
      e.preventDefault();
    });
    el.addEventListener('pointermove', function (e) {
      if (!start) return;
      var w = wb(start.st);
      if (start.sl.x >= 1) w.x = Math.max(0, Math.min(100, start.wx - (e.clientX - start.x) / start.sl.x * 100));
      if (start.sl.y >= 1) w.y = Math.max(0, Math.min(100, start.wy - (e.clientY - start.y) / start.sl.y * 100));
      schedule();
    });
    ['pointerup', 'pointercancel', 'lostpointercapture'].forEach(function (t) {
      el.addEventListener(t, function () { if (start) { start = null; schedule(); } });
    });
  }

  // The main preview's img is replaced on every upload, so bind on the frame (delegated).
  (function bindMainPan() {
    var start = null, el = null;
    document.addEventListener('pointerdown', function (e) {
      var t = e.target;
      if (!t || !t.closest || !t.closest('.left-frame-preview .image-frame.smw-wb-on')) return;
      var st = activeState();
      if (!geo || !live(st)) return;
      var sl = slack(geo);
      if (sl.x < 1 && sl.y < 1) return;
      el = geo.el;
      start = { x: e.clientX, y: e.clientY, wx: wb(st).x, wy: wb(st).y, sl: sl, st: st, k: el.getBoundingClientRect().width / geo.W || 1 };
      try { el.setPointerCapture(e.pointerId); } catch (x) {}
      e.preventDefault();
    });
    document.addEventListener('pointermove', function (e) {
      if (!start) return;
      var w = wb(start.st), k = start.k;
      if (start.sl.x >= 1) w.x = Math.max(0, Math.min(100, start.wx - (e.clientX - start.x) / k / start.sl.x * 100));
      if (start.sl.y >= 1) w.y = Math.max(0, Math.min(100, start.wy - (e.clientY - start.y) / k / start.sl.y * 100));
      schedule();
    });
    ['pointerup', 'pointercancel'].forEach(function (t) {
      document.addEventListener(t, function () { if (start) { start = null; schedule(); } });
    });
  })();

  /* ---------- bordered art for the room view / AR (smw-room-view.js) ---------- */

  var room = { key: '', url: '', old: [] }, roomTimer = 0;
  function queueRoomArt(st) {
    if (!live(st) || room.key === keyFor(st)) return;
    clearTimeout(roomTimer);
    roomTimer = setTimeout(function () {
      var s = activeState();
      if (!live(s)) return;
      var key = keyFor(s);
      if (room.key === key) return;
      getImg(s.uploadedImage).then(function (img) {
        if (keyFor(s) !== key) return;
        return toBlob(render(img, s, 1600), 0.9).then(function (b) {
          if (room.url) room.old.push(room.url);
          while (room.old.length > 4) URL.revokeObjectURL(room.old.shift());
          room.key = key;
          room.url = URL.createObjectURL(b);
        });
      }).catch(function () {});
    }, 300);
  }
  function roomArt() {
    var st = activeState();
    return live(st) && room.key === keyFor(st) ? room.url : null;
  }

  /* ---------- wiring ---------- */

  var raf = 0;
  function schedule() { if (!raf) raf = requestAnimationFrame(function () { raf = 0; update(); }); }
  function update() {
    wrapApprove();
    var st = activeState();
    applyPreview(st);
    refreshPanel(st);
    queueRoomArt(st);
    attach();
  }

  var mo = new MutationObserver(schedule), watched = [];
  function watch(el, opts) { if (el && watched.indexOf(el) < 0) { watched.push(el); mo.observe(el, opts); } }
  function attach() {
    watch(document.querySelector('.grid--product-images--partial'), { attributes: true, attributeFilter: ['data-border', 'data-frame', 'data-frame-orientation'] });
    var fr = document.querySelector('.left-frame-preview .image-frame');
    if (fr) {
      watch(fr, { childList: true });
      var img = fr.querySelector('img');
      if (img) watch(img, { attributes: true, attributeFilter: ['src'] });
      if (!fr.__smwWbLoad) { fr.__smwWbLoad = true; fr.addEventListener('load', schedule, true); }
    }
  }

  // Selections settle on timers (custom.js sets the frame/border attributes 500 ms after a change).
  document.addEventListener('change', function () { schedule(); setTimeout(schedule, 650); }, true);
  document.addEventListener('click', function () { setTimeout(schedule, 350); setTimeout(schedule, 900); }, true);
  var lastW = window.innerWidth;
  window.addEventListener('resize', function () { if (window.innerWidth !== lastW) { lastW = window.innerWidth; schedule(); } });

  window.smwWB = { ready: ready, props: props, roomArt: roomArt, refresh: schedule };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', schedule); else schedule();
})();
